import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatService } from '../../chat.service';
import { ConversationSummary } from '../../core/hub-types';

/** The practice's public channels the user has not joined: read one, or join it straight away. */
@Component({
  selector: 'app-browse-channels-dialog',
  template: `
    <h2 mat-dialog-title>Browse groups</h2>
    <mat-dialog-content>
      <div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>
      <p class="hint" *ngIf="!loading && !channels.length">There are no other public groups in this practice.</p>
      <p class="error" *ngIf="error">{{ error }}</p>
      <div class="row" *ngFor="let c of channels">
        <mat-icon>groups</mat-icon>
        <div class="text">
          <strong>{{ c.name }}</strong>
          <span *ngIf="c.description">{{ c.description }}</span>
        </div>
        <button mat-button (click)="view(c)">View</button>
        <button mat-flat-button color="primary" (click)="join(c)" [disabled]="busy">Join</button>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end"><button mat-button mat-dialog-close>Close</button></mat-dialog-actions>
  `,
  styles: [
    `.row { display: flex; flex-wrap: nowrap; align-items: center; gap: 8px; margin: 0; padding: 6px 0; }
     .text { flex: 1; min-width: 0; display: flex; flex-direction: column; }
     .text span { font-size: 12px; opacity: 0.7; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
     .loading { display: flex; justify-content: center; padding: 16px; }
     .hint { opacity: 0.7; } .error { color: #ef5350; }`,
  ],
})
export class BrowseChannelsDialogComponent implements OnInit {
  channels: ConversationSummary[] = [];
  loading = true;
  busy = false;
  error = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: { orgId: string },
    private readonly ref: MatDialogRef<BrowseChannelsDialogComponent, string>,
    private readonly chat: ChatService,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.channels = await this.chat.store.browse(this.data.orgId);
    } catch {
      this.error = 'Could not load groups.';
    } finally {
      this.loading = false;
    }
  }

  view(c: ConversationSummary): void {
    this.ref.close(c.id);
  }

  async join(c: ConversationSummary): Promise<void> {
    this.busy = true;
    try {
      await this.chat.store.join(c.id);
      this.ref.close(c.id);
    } catch {
      this.error = 'Could not join the group.';
      this.busy = false;
    }
  }
}
